import { render } from "./BaseRegSizeForm.vue?vue&type=template&id=69afc770&scoped=true"
import script from "./BaseRegSizeForm.vue?vue&type=script&lang=js"
export * from "./BaseRegSizeForm.vue?vue&type=script&lang=js"

import "./BaseRegSizeForm.vue?vue&type=style&index=0&id=69afc770&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69afc770"]])

export default __exports__